module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.99fc081.ttf";